var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8833 9.93267L14.4699 13.5193C14.596 13.6455 14.6668 13.8166 14.6667 13.9949C14.6667 14.1733 14.5957 14.3443 14.4696 14.4703C14.3434 14.5964 14.1724 14.6672 13.994 14.6671C13.8157 14.6671 13.6447 14.5962 13.5186 14.47L9.93193 10.8833C8.85973 11.7138 7.51145 12.1046 6.16134 11.9762C4.81124 11.8479 3.56075 11.21 2.66425 10.1924C1.76775 9.1748 1.29259 7.85388 1.33543 6.49836C1.37827 5.14285 1.93589 3.85457 2.89486 2.8956C3.85383 1.93663 5.14211 1.37901 6.49762 1.33617C7.85314 1.29333 9.17406 1.76849 10.1917 2.66499C11.2093 3.56149 11.8471 4.81198 11.9755 6.16208C12.1038 7.51219 11.713 8.86047 10.8826 9.93267H10.8833ZM6.66659 10.6667C7.72746 10.6667 8.74487 10.2452 9.49502 9.49509C10.2452 8.74495 10.6666 7.72753 10.6666 6.66667C10.6666 5.6058 10.2452 4.58839 9.49502 3.83824C8.74487 3.08809 7.72746 2.66667 6.66659 2.66667C5.60573 2.66667 4.58831 3.08809 3.83817 3.83824C3.08802 4.58839 2.66659 5.6058 2.66659 6.66667C2.66659 7.72753 3.08802 8.74495 3.83817 9.49509C4.58831 10.2452 5.60573 10.6667 6.66659 10.6667Z",
    fill: "#5292D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeSearch);
export default __webpack_public_path__ + "static/media/fe_search.c801a7c1.svg";
export { ForwardRef as ReactComponent };